(ns minorodata.ingest.model
  (:require [mold.core :as m :refer-macros [defmodel]]))


(defmodel ingest
  {:ingest-id      [::m/string ::m/req ::m/identity "Uniq id"]
   :version        [::m/string ::m/req "Ingest version"]
   :source-type    [::m/string "Ingest source type"]
   :description    [::m/string ::m/nilable "Ingest source description"]
   :cpu            [::m/string ::m/nilable "AWS cpu usage"]
   :mem            [::m/string ::m/nilable "AWS mem usage"]
   :task-name      [::m/string "Task id"]
   :created-at     [::m/string "Timestamp"]
   :requires-nat   [::m/bool "Requires NAT access"]})


(defmodel jumper-source
  {:jumper-source-id [::m/string ::m/req ::m/identity "Uniq id"]
   :ingest-id        [::m/string ::m/req ::m/identity "Ingest id"]
   :created-at       [::m/string "Timestamp"]

   :metadata         [::m/map "Source description"]
   :form             [::m/map "Source form definition"]})


(defmodel jumper-extract
  {:jumper-extract-id [::m/string ::m/req ::m/identity "Uniq id"]
   :ingest-id         [::m/string ::m/req ::m/identity "Ingest id"]
   :created-at        [::m/string "Timestamp"]

   :metadata          [::m/map "Extract display preferences"]
   :form              [::m/map "Extract form definition"]})
